import moment from 'moment';
import { constants } from '../../../constants/constants';
import { DateTimeStamp } from '../../../types/primitives/DateTimeStamp';

interface Props {
    publishingDate: DateTimeStamp;
}

const renderTimeLabel = (publishingDate: DateTimeStamp) => {
    const now = moment.utc();
    const newsDate = moment.utc(publishingDate);

    const hoursPassed = Math.floor(moment.duration(now.diff(newsDate)).asHours());

    if (hoursPassed >= 24 || hoursPassed < 0) {
        return newsDate.utc().format(constants.dateFormatDoubleDay);
    }

    // ¯\_(ツ)_/¯
    if (hoursPassed <= 1) {
        return `1 hour ago`;
    }

    return `${hoursPassed} hours ago`;
};

// TO DO: Add unit tests
export const TimeLabel = ({ publishingDate }: Props) => (
    <time className="news-item-time">{renderTimeLabel(publishingDate)}</time>
);
